var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconEdit',{staticClass:"transition duration-200 cursor-pointer text-icon hover:text-icon-hover overflow-visible",nativeOn:{"click":function($event){return _vm.$emit('edit')}}})}
var staticRenderFns = []

export { render, staticRenderFns }